// extracted by css-extract-rspack-plugin
export default {"OmnibarDrawerContainer":"omnibar-drawer-module__OmnibarDrawerContainer__whxHu"};